import { AutoComplete } from '@openx/components-core/lib/AutoComplete/AutoComplete';
import type { AudienceOption } from '@openx/types/targeting/audience';
import { useTranslation } from 'react-i18next';
import { useTargetingOptionDisabledState } from '../../../utils/hooks/useTargetingOptionDisabledState';
import { useAudienceTypeOption } from '../hooks/useAudienceTypeOption';

type AudienceTypeOptionProps = {
  onChange: (type: AudienceOption) => void;
  value: AudienceOption;
};

export const TypeOptionDropdown = ({ onChange, value }: AudienceTypeOptionProps) => {
  const { t } = useTranslation();
  const { labels } = useAudienceTypeOption();
  const { isOptionDisabled } = useTargetingOptionDisabledState();

  return (
    <AutoComplete<AudienceOption, false, true, false>
      textFieldProps={{ label: t('Type') }}
      options={Object.keys(labels) as AudienceOption[]}
      renderOptions={{
        dataTest: 'type-option',
        getOptionValue: optionId => labels[optionId]!,
      }}
      getOptionLabel={option => labels[option] || option}
      getOptionDisabled={option => isOptionDisabled(option)}
      textFieldReadOnly
      disableClearable
      filterOptions={option => option}
      onChange={(_e, value) => onChange(value)}
      value={value}
      fullWidth
      data-test="audience-type"
    />
  );
};
